import { makeAutoObservable } from "mobx";
import { getClinic } from "../http/clinicAPI";

export default class ClinicStore {
  constructor() {
    this._clinic = {
      name: "",
      systemName: "",
      logo: "",
      balance: 0,
      disableUserBirthday: false,
      showAllDoctorsInBot: false
    };
    makeAutoObservable(this);
  }

  async getClinic() {
    const clinicData = await getClinic();
    this.setClinicData(clinicData);
    return clinicData;
  }

  setClinicData(clinicData) {
    this._clinic = {
      name: clinicData?.name || "",
      systemName: clinicData?.system?.name || "",
      logo: clinicData?.imageFileName || "",
      balance: clinicData?.balance || 0,
      disableUserBirthday: clinicData?.disableUserBirthday || false,
      showAllDoctorsInBot: clinicData?.showAllDoctorsInBot || false
    };
  }

  setSystemName(systemName) {
    this._clinic = { ...this._clinic, systemName: systemName };
    localStorage.setItem("systemName", systemName);
  }

  setName(name) {
    this._clinic = { ...this._clinic, name: name };
    localStorage.setItem("name", name);
  }

  setBalance(balance) {
    this._clinic = { ...this._clinic, balance: balance };
  }

  setLogo(logo) {
    this._clinic = { ...this._clinic, logo: logo };
  }

  setDisableUserBirthday(disableUserBirthday) {
    this._clinic = { ...this._clinic, disableUserBirthday: disableUserBirthday };
  }

  setShowAllDoctorsInBot(showAllDoctorsInBot){
    this._clinic = { ...this._clinic, showAllDoctorsInBot: showAllDoctorsInBot };
  }

  get name() {
    return this._clinic.name;
  }

  get systemName() {
    return this._clinic.systemName;
  }

  get logo() {
    return this._clinic.logo;
  }

  get balance() {
    return this._clinic.balance;
  }

  get disableUserBirthday() {
    return this._clinic.disableUserBirthday;
  }

  get showAllDoctorsInBot(){
    return this._clinic.showAllDoctorsInBot;
  }
}
